import React from 'react';
import CustomerTextInput from '../../../inputs/customerTextInput/CustomerTextInput';
import useTranslation from '../../../../hooks/translation/useTranslation';
import CustomerPhoneNumberInput from '../../../inputs/customerPhoneInput/CustomerPhoneNumberInput';
import { useBooking } from '../../../../contexts/ticketBookingContext/TicketBookingContext';

function PhysicalCustomerBookingInfo() {
  const { trans } = useTranslation();
  const { options } = useBooking();
  return (
    <>
      <CustomerTextInput
        label={trans('first_name')}
        name={['booker', 'first_name']}
        disabled
        rules={[{
          required: true,
          message: trans('input_necessary'),
        }]}
      />
      <CustomerTextInput
        label={trans('last_name')}
        name={['booker', 'last_name']}
        disabled
        rules={[{
          required: true,
          message: trans('input_necessary'),
        }]}
      />
      <CustomerTextInput
        label={trans('document_number')}
        name={['booker', 'id_number']}
        disabled
        rules={[{
          required: true,
          message: trans('input_necessary'),
        }]}
      />
      <CustomerPhoneNumberInput
        label={trans('phone_number')}
        name={['booker', 'phone_number']}
        selectName={['booker', 'country_phone_code']}
        options={options.phoneCodes}
        disabled
        codeSelectDisabled
        rules={[{
          required: true,
          message: trans('input_necessary'),
        }]}
      />
      <CustomerTextInput
        label={trans('email')}
        name={['booker', 'email']}
        disabled
        rules={[{
          required: true,
          message: trans('input_necessary'),
        }]}
      />
      <CustomerTextInput
        label={trans('citizenship')}
        name={['booker', 'country']}
        disabled
        rules={[{
          required: true,
          message: trans('input_necessary'),
        }]}
      />
      <CustomerTextInput
        label={trans('address')}
        name={['booker', 'address']}
        rules={[{
          required: true,
          message: trans('input_necessary'),
        }]}
      />
    </>
  );
}

export default PhysicalCustomerBookingInfo;
